export default __webpack_public_path__ + "img/orkpipo-svc-apim-portail.c66b25b8.svg";